export const getDiscountedPrice = (product) => {
    if (!product || !product.price) return 0;

    // Convert string price to number if needed (handling "120.50" or numbers)
    const originalPrice = Number(product.price);
    if (isNaN(originalPrice)) return 0;

    if (!product.discount || !product.discount.isActive) {
        return originalPrice;
    }

    const { type, value } = product.discount;
    let finalPrice = originalPrice;

    if (type === 'percent') {
        const discountAmount = (originalPrice * value) / 100;
        finalPrice = originalPrice - discountAmount;
    } else if (type === 'amount') {
        finalPrice = originalPrice - value;
    }

    return Math.max(0, Number(finalPrice.toFixed(2))); // Ensure no negative prices and 2 decimals
};

export const getDiscountPercent = (product) => {
    if (!product || !product.discount || !product.discount.isActive) return 0;

    const { type, value, price } = product;

    if (type === 'percent') {
        return Math.round(value);
    } else if (type === 'amount') {
        // Calculate percent equivalent for fixed amount discount
        const originalPrice = Number(product.price);
        if (!originalPrice) return 0;
        const percent = (product.discount.value / originalPrice) * 100;
        return Math.round(percent);
    }
    return 0;
};

export const formatPrice = (price) => {
    if (price === undefined || price === null) return "0 ₺";
    return `${Number(price).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
};
